<script setup>
import { onMounted, ref, watch } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';
import TeleportWithDirection from 'dashboard/components-next/TeleportWithDirection.vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { useLocoI18n } from 'custom/composables/useLocoI18n';
import { useAiSettings } from './useAiSettings';
import AiCopilotPanel from './AiCopilotPanel.vue';

// In the conversation header: opens the copilot, when the account has AI set up
defineProps({
  conversationId: { type: Number, required: true },
});

const { t } = useLocoI18n();
const { isConfigured, load } = useAiSettings();
const { uiSettings, updateUISettings } = useUISettings();
const accountId = useMapGetter('getCurrentAccountId');
const isFeatureEnabledonAccount = useMapGetter(
  'accounts/isFeatureEnabledonAccount'
);
const isOpen = ref(false);

// "Ask Copilot" in the reply box's AI menu opens Captain's copilot, which needs Chatwoot Enterprise. Without it,
// it opens this one.
watch(
  () => uiSettings.value.is_copilot_panel_open,
  open => {
    if (!open || !isConfigured.value) return;
    if (isFeatureEnabledonAccount.value(accountId.value, FEATURE_FLAGS.CAPTAIN))
      return;
    isOpen.value = true;
    updateUISettings({ is_copilot_panel_open: false });
  }
);

onMounted(load);
</script>

<template>
  <template v-if="isConfigured">
    <Button
      v-tooltip.bottom="t('LOCO.AI.COPILOT.TITLE')"
      icon="i-lucide-sparkles"
      sm
      ghost
      slate
      @click="isOpen = !isOpen"
    />
    <TeleportWithDirection to="body">
      <AiCopilotPanel
        v-if="isOpen"
        :conversation-id="conversationId"
        @close="isOpen = false"
      />
    </TeleportWithDirection>
  </template>
</template>
